import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import GameQuery from '../../query/GameQuery';
import ToggleShowSubmissionPopupMutation from '../../mutations/ToggleShowSubmissionPopup';
import SubmitComponent from '../../components/Submit';
const SubmissionButton = ({ disabled }) => {
	return (
		<GameQuery>
			{query => (
				<ToggleShowSubmissionPopupMutation>
					{toggleShowSubmissionPopup => (
						<SubmitComponent
							disabled={disabled}
							onClick={toggleShowSubmissionPopup}
							label={'Submissions'}
							count={query.game.lastSubmission}
						/>
					)}
				</ToggleShowSubmissionPopupMutation>
			)}
		</GameQuery>
	);
};

SubmissionButton.propTypes = {
	count: PropTypes.number
};

export default SubmissionButton;
